<template>
  <section class="page-title">
    <div class="page-title__inner container">
      <h1 class="page-title__title">{{ title }}</h1>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<style lang="scss" scoped>
.page-title {
  background-color: $c-bg;
  padding: 32px 0;
  @media only screen and (max-width: $w-tablet-s) {
    display: none;
  }
  &__title {
    font-size: 28px;
    line-height: 1.25em;
    letter-spacing: -0.02em;
  }
}
.night-mode {
  .page-title {
    background-color: $c-dark-2;
  }
}
</style>
